module.exports = __webpack_public_path__ + "img/page-065.803501d6.jpg";